
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/compliance/resources/accident-prevention-compliance",
      function () {
        return require("private-next-pages/compliance/resources/accident-prevention-compliance.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/compliance/resources/accident-prevention-compliance"])
      });
    }
  